<script>
    import { t } from '../i18n.js'
    import ViewCardContainer from '../components/ViewCardContainer.svelte'
    import { onMount } from 'svelte'

    onMount(() => {
		window.scrollTo(0,0)
	})
</script>

<ViewCardContainer pageTitle={$t('info.page-title')}> 
    <h2 class="mb-2">{$t('info.welcome-subtitle')}</h2>
    <p class="mb-4">{$t('info.platform-welcome-1')}</p>
    <p class="mb-4">{$t('info.platform-welcome-bullet-1')}</p>
    <p class="mb-4">{$t('info.platform-welcome-bullet-2')}</p>
    <p class="mb-4">{$t('info.platform-welcome-2')}</p>
    <p class="mb-4">{$t('info.platform-welcome-bullet-3')}</p>
    <p class="mb-4">{$t('info.platform-welcome-bullet-4')}</p>
    <p class="mb-4">{$t('info.platform-welcome-bullet-5')}</p>
    <h2 class="mb-2">{$t('info.platform-subtitle')}</h2>
    <p class="mb-4">{$t('info.platform-principles')}</p>
    <p class="mb-4">{$t('info.platform-cooperation')}</p>
    <p class="mb-4">{$t('info.platform-open-source')}</p>

    <h2 class="mt-8 mb-2">{$t('info.services-subtitle')}</h2>
    <p class="mb-4">{$t('info.services-apis')}</p>
    <p class="mb-4">{$t('info.services-analysis')}</p>
    <p class="mb-4">{$t('info.services-data-storage')}</p>
    <p class="mb-4">{$t('info.services-user-management')}</p>
  

    <div class="mt-8 mb-4 flex justify-center">
        <img src="{$t('info.img-src')}" alt="{$t('info.kerroskuva-alt')}">
    </div>
</ViewCardContainer>